<template>
    <div class="bg-white shadow-md rounded-xl p-6 w-full flex flex-col justify-between">
      <div class="overflow-hidden">
        <p class="text-gray-900 font-semibold text-lg">Daily Visit</p>
        <highcharts :options="chartOptions"></highcharts>
        <!-- Active User Legend -->
      </div>
      <div class="flex items-center justify-center text-sm text-gray-600">
          <div class="w-3 h-3 bg-[#1307A8] rounded-full mr-2"></div>
          Visitors - {{ this.countvisitors }}
      </div>
    </div>
  </template> 
  
  <script>
  import HighchartsVue from 'highcharts-vue';
  import Api from '../../../router/api';
  import Vue from "vue";
  export default {
    components: {
      HighchartsVue
    },
    data() {
      return {
        countvisitors:2,
        chartOptions: {
          chart: {
            type: 'column',
            height: 300,
            backgroundColor:"transparent"
            
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: []
          },
          yAxis: {
            title: {
              text: 'Visitors'
            },
            
          },
          series: [{
            name: 'Visitors',
            data: [],
            showInLegend: false
          }],
          colors: ['#1307A8'],
          plotOptions: {
            column: {
              borderRadius: 8, // <-- This adds rounded corners
              pointPadding: 0.2, // Adjust spacing between bars
              groupPadding: 0.1  // Adjust spacing between groups of bars
            }
          },
          credits: {
              enabled: false
          }
          // Add more Highcharts options if needed 
        }
      };
    },
    methods:{
        
    },
    mounted() 
    {
      var that = this;
      Api.dailyVisit().then((e)=>{ 
          //console.log({data:e.data.data},"Daily visit");
          that.countvisitors = e.data.daily_visitors_user;
          Vue.set(that.chartOptions.xAxis, 'categories', e.data.categories);
          Vue.set(that.chartOptions.yAxis, 'tickPositions', e.data.tick_positions);
          Vue.set(that.chartOptions.series[0], 'data', e.data.data);
      }).catch((e)=>{
        console.log(e);
      })
        console.log(that.chartOptions,'visitors')

    }

  };
  </script>
  
  <style>
  /* Your styles here if needed */
  </style>
  


// WEBPACK FOOTER //
// src/components/admin/dashboard1/DailyVisit.vue